import FallbackDB from "@/libraries/localStorage";

export const users = {
    namespaced: true,
    state() {
        return {
            DB: [],
            CURRENT_USER_ID: 0,
        }
    },
    getters: {
        getDB(state) {
            return state.DB;
        },
        getCurrentUserID(state) {
            return state.CURRENT_USER_ID;
        },
    },
    mutations: {
        setDB(state, value) {
            state.DB = value;
        },
        setCurrentUserID(state, value) {
            state.CURRENT_USER_ID = value;
            +value
                ? localStorage.setItem('g_user_id', value)
                : localStorage.removeItem('g_user_id');
        }
    },
    actions: {
        restore({commit}) {
            commit('setDB', FallbackDB.restore('users'));
            commit('setCurrentUserID', localStorage.getItem('g_user_id'));
        },
        init({commit}) {
        },
    }
}